module.exports = __webpack_public_path__ + "img/collaborate_21.981739f1.jpg";